import { getAmplitudeInstance } from '../amplitudeHelpers';
import TrailDetailsSeeAllLocation from '../enums/TrailDetailsSeeAllLocation';

type logTrailDetailsSeeAllClickedParams = {
  location?: TrailDetailsSeeAllLocation;
  trail_id: number;
};

/**
 * User clicks the see all reviews button.
 * @param params - Attributes to log with the amplitude event
 * @param params.location - The location of the 'see all' on the trail details page.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsSeeAllClicked = ({ location, trail_id }: logTrailDetailsSeeAllClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details see all clicked', { location, 'trail id': trail_id }, callback);
};

export default logTrailDetailsSeeAllClicked;
